(() => {
  if (customElements.get('es-cart-drawer')) return;
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.root = this.closest('#CartDrawer');
      this.content = this.querySelector('[data-es-cart-content]');
      this.error = this.querySelector('[data-es-cart-error]');
      this.slide = 0;
      this.busy = false;
      this.drawer = { isOpen: false, open: () => this.open(), close: () => this.close() };
      this.root.inert = true;
      this.root.setAttribute('aria-hidden', 'true');
      document.querySelectorAll('.js-drawer-open-cart').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => this.click(event), options);
      this.addEventListener('change', event => this.change(event), options);
      this.addEventListener('input', event => {
        if (event.target.matches('[data-es-cart-note]')) this.noteDraft = event.target.value;
      }, options);
      this.addEventListener('submit', event => {
        if (this.busy) event.preventDefault();
      }, options);
      this.querySelector('.js-drawer-close').addEventListener('click', () => this.close(), options);
      document.getElementById('esCartBackdrop').addEventListener('click', () => this.close(), options);
      document.addEventListener('click', event => {
        const trigger = event.target.closest('.js-drawer-open-cart');
        if (!trigger) return;
        event.preventDefault();
        event.stopPropagation();
        this.returnFocus = trigger;
        this.open();
      }, { capture: true, signal: this.controller.signal });
      document.addEventListener('keydown', event => {
        if (!this.drawer.isOpen) return;
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(); }
        if (event.key !== 'Tab') return;
        const nodes = [...this.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled])')].filter(node => node.getClientRects().length);
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        else if (document.activeElement === this.root || !this.contains(document.activeElement)) {
          event.preventDefault();
          (event.shiftKey ? last : first)?.focus();
        }
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.drawer.open();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.cards().findIndex(card => card.dataset.esBlockId === event.detail.blockId);
        if (index >= 0) {
          this.drawer.open();
          this.slide = index;
          this.showSlide();
        } else {
          const block = [...this.querySelectorAll('[data-es-block-id]')].find(node => node.dataset.esBlockId === event.detail.blockId);
          if (block) { this.open(); block.scrollIntoView({ block: 'nearest' }); }
        }
      }, options);
      this.namespace = '.esCartDrawer';
      window.jQuery(document.body).off(this.namespace).on('added.ajaxProduct' + this.namespace, () => {
        this.returnFocus = document.activeElement;
        this.refresh(true);
      });
      this.showSlide();
      this.updateCount();
      this.ensureDefaultExtra();
      if (window.Shopify?.designMode && document.body.dataset.esCartEditorOpen === 'true') {
        delete document.body.dataset.esCartEditorOpen;
        this.open();
      }
    }
    disconnectedCallback() {
      const keepOpen = this.drawer?.isOpen && window.Shopify?.designMode;
      this.close(false);
      if (keepOpen) document.body.dataset.esCartEditorOpen = 'true';
      this.controller?.abort();
      window.jQuery(document.body).off(this.namespace);
      this.controller = null;
    }
    open() {
      if (this.drawer.isOpen) return;
      if (!this.returnFocus || this.contains(this.returnFocus)) this.returnFocus = document.activeElement;
      this.drawer.isOpen = true;
      this.root.inert = false;
      this.root.setAttribute('aria-hidden', 'false');
      this.root.classList.add('drawer--is-open');
      document.documentElement.classList.add('js-drawer-open', 'es-cart-open');
      document.body.classList.add('js-drawer-open');
      const page = document.getElementById('PageContainer');
      if (page) page.inert = true;
      document.querySelectorAll('.js-drawer-open-cart').forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
      window.jQuery(document.body).trigger('drawerOpen').trigger('drawerOpen.CartDrawer');
      requestAnimationFrame(() => {
        if (this.drawer.isOpen) this.querySelector('.js-drawer-close').focus({ preventScroll: true });
      });
    }
    close(restoreFocus = true) {
      if (!this.drawer?.isOpen) return;
      this.drawer.isOpen = false;
      this.root.classList.remove('drawer--is-open');
      document.documentElement.classList.remove('js-drawer-open', 'es-cart-open');
      document.body.classList.remove('js-drawer-open');
      const page = document.getElementById('PageContainer');
      if (page) page.inert = false;
      document.querySelectorAll('.js-drawer-open-cart').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      if (restoreFocus && this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      else if (this.contains(document.activeElement)) document.activeElement.blur();
      this.root.inert = true;
      this.root.setAttribute('aria-hidden', 'true');
    }
    cards() {
      return [...this.querySelectorAll('[data-es-recommendation]')];
    }
    showSlide() {
      const cards = this.cards();
      this.slide = cards.length ? (this.slide + cards.length) % cards.length : 0;
      cards.forEach((card, index) => { card.hidden = index !== this.slide; });
      this.querySelectorAll('[data-es-slide]').forEach(button => { button.hidden = cards.length < 2; });
    }
    click(event) {
      const step = event.target.closest('[data-es-quantity-step]');
      const remove = event.target.closest('[data-es-remove]');
      const slide = event.target.closest('[data-es-slide]');
      if (slide) {
        this.slide += Number(slide.dataset.esSlide);
        this.showSlide();
      }
      if (!step && !remove) return;
      event.preventDefault();
      if (this.busy) return;
      const line = (step || remove).closest('[data-es-line-key]');
      const quantity = remove ? 0 : Math.max(0, Number(line.querySelector('[data-es-quantity]').value) + Number(step.dataset.esQuantityStep));
      if (!Number.isInteger(quantity)) return;
      this.changeLine(line.dataset.esLineKey, quantity, step?.dataset.focusToken);
    }
    change(event) {
      const target = event.target;
      if (this.busy) return;
      if (target.matches('[data-es-quantity]')) {
        const quantity = Number(target.value);
        if (!Number.isInteger(quantity) || quantity < 0) return this.refresh();
        this.changeLine(target.closest('[data-es-line-key]').dataset.esLineKey, quantity, target.dataset.focusToken);
      }
      if (target.matches('[data-es-recommendation-variant]')) {
        const option = target.selectedOptions[0];
        const card = target.closest('[data-es-recommendation]');
        const link = card.querySelector('[data-es-recommendation-link]');
        const url = new URL(link.href);
        url.searchParams.set('variant', target.value);
        link.href = url.href;
        card.querySelector('[data-es-recommendation-price]').textContent = option.dataset.price;
        const compare = card.querySelector('[data-es-recommendation-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = option.dataset.onSale !== 'true';
      }
      if (target.matches('[data-es-extra]')) {
        const updates = target.checked
          ? { [target.dataset.variantId]: 1 }
          : Object.fromEntries(target.dataset.lineKeys.split('|').filter(Boolean).map(key => [key, 0]));
        this.mutate('cart/update.js', {
          updates,
          attributes: { es_verzekerde_verzending: target.checked ? 'on' : 'off' }
        }, 'insurance');
      }
    }
    async ensureDefaultExtra() {
      const extra = this.querySelector('[data-es-extra]');
      if (this.busy || this.autoExtraAttempted || !extra || extra.checked || extra.dataset.defaultOn !== 'true' || extra.dataset.choice === 'off') return;
      this.autoExtraAttempted = true;
      await this.mutate('cart/update.js', {
        updates: { [extra.dataset.variantId]: 1 },
        attributes: { es_verzekerde_verzending: 'on' }
      });
    }
    changeLine(id, quantity, focusToken) {
      const extra = this.querySelector('[data-es-extra]');
      if (quantity === 0 && extra && this.querySelectorAll('.es-cart__items [data-es-line-key]').length === 1) {
        const updates = Object.fromEntries(extra.dataset.lineKeys.split('|').filter(Boolean).map(key => [key, 0]));
        updates[id] = 0;
        this.mutate('cart/update.js', { updates, attributes: { es_verzekerde_verzending: '' } }, focusToken);
      } else {
        this.mutate('cart/change.js', { id, quantity }, focusToken);
      }
    }
    setBusy(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      this.querySelectorAll('button:not(.js-drawer-close),input,select,textarea').forEach(control => { control.disabled = busy; });
    }
    async mutate(path, body, focusToken) {
      if (this.busy) return;
      this.setBusy(true);
      this.error.hidden = true;
      try {
        const response = await fetch(this.dataset.root + path, {
          method: 'POST', credentials: 'same-origin',
          signal: this.controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...body, sections: [this.dataset.sectionId], sections_url: location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(data.description || this.dataset.error);
        const html = data.sections?.[this.dataset.sectionId] || await this.fetchSection();
        this.render(html, focusToken);
      } catch (error) {
        if (!this.isConnected) return;
        try { this.render(await this.fetchSection()); } catch {}
        this.showError(error);
        const extra = this.querySelector('[data-es-extra]');
        if (extra) extra.checked = extra.dataset.lineKeys.length > 0;
      } finally {
        this.setBusy(false);
        if (this.openAfterRefresh && this.isConnected) {
          this.openAfterRefresh = false;
          this.refresh(true);
        }
      }
    }
    async fetchSection() {
      const url = new URL(this.dataset.root, location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
      if (!response.ok) throw new Error(this.dataset.error);
      return response.text();
    }
    async refresh(open = false) {
      if (this.busy) { this.openAfterRefresh = this.openAfterRefresh || open; return; }
      this.setBusy(true);
      this.error.hidden = true;
      try {
        this.render(await this.fetchSection());
      } catch (error) {
        if (this.isConnected) this.showError(error);
      } finally {
        this.setBusy(false);
        if (this.isConnected) await this.ensureDefaultExtra();
        if (this.isConnected && (open || this.openAfterRefresh)) this.drawer.open();
        this.openAfterRefresh = false;
      }
    }
    render(html, focusToken) {
      if (!this.isConnected) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-es-cart-content]');
      if (!content) throw new Error(this.dataset.error);
      const scroll = this.content.scrollTop;
      this.content.replaceChildren(...document.importNode(content, true).childNodes);
      this.content.dataset.count = content.dataset.count;
      if (Number(content.dataset.count) === 0) this.autoExtraAttempted = false;
      const note = this.querySelector('[data-es-cart-note]');
      if (note && this.noteDraft !== undefined) note.value = this.noteDraft;
      this.showSlide();
      this.updateCount();
      this.content.scrollTop = scroll;
      if (focusToken) requestAnimationFrame(() => this.querySelector(`[data-focus-token="${CSS.escape(focusToken)}"]`)?.focus({ preventScroll: true }));
    }
    updateCount() {
      const count = Number(this.content.dataset.count) || 0;
      this.querySelectorAll('[data-es-cart-count]').forEach(node => { node.textContent = String(count); });
      document.querySelectorAll('.cart-link__bubble').forEach(node => { node.classList.toggle('cart-link__bubble--visible', count > 0); });
      this.querySelector('[data-es-cart-announcement]').textContent = `${this.querySelector('#esCartTitle').textContent.trim()}`;
    }
    showError(error) {
      this.error.textContent = error instanceof TypeError || error instanceof SyntaxError ? this.dataset.error : error?.message || this.dataset.error;
      this.error.hidden = false;
    }
  }
  customElements.define('es-cart-drawer', CartDrawer);
})();
